import { useMemo } from "react"
import { useAsyncValue } from "../../../../../shared/react/hooks"
import { escape } from "../../../../../shared/utils/regexp"
import { HoldingPermissionsApi } from "../api"
import { getInitialState, updateState, View } from "../state"

export type AppDispatch = ReturnType<typeof useHoldingPermissionsEditor>["dispatch"]

export function useHoldingPermissionsEditor(api: HoldingPermissionsApi, initialView?: View) {

    const [state, dispatch] = React.useReducer(
        updateState,
        { api, initialView },
        getInitialState
    )

    useAsyncValue(async () => {

        const payload = await api.fetchApiData()

        dispatch({ type: "load", payload })

    }, [api, dispatch])


    return { state, dispatch }

}


export function useFilteredUsers<U>(users: U[], filter: string, selector: (u: U) => { name: string, email: string, shouldRetain: boolean }) {

    return useMemo(() => {

        const all = users
        let visible = users

        if (filter) {

            const re = new RegExp(escape(filter), "i")

            visible = users.filter(u => {
                const t = selector(u)
                return t.shouldRetain || re.test(t.name) || re.test(t.email)
            })

        }

        return {
            all,
            visible
        }

    }, [users, filter, selector])

}
